import React, { ReactNode } from 'react';
import { getConfig, webOptions } from './config';
import { PostHogProvider as PostHogWebProvider  } from 'posthog-js/react';
import { BeforeSendFn } from 'posthog-js';

type PostHogProviderProps = {
  children: ReactNode;
};

export const PostHogProvider = ({ children }: PostHogProviderProps) => {
  const before_send: BeforeSendFn = (event) => {
    // TODO: Add custom logic for exceptions to send to posthog
    return event;
  };

  const config = getConfig(window.location.hostname, false)

  return (
    <PostHogWebProvider
      apiKey={config.apiKey}
      options={{...webOptions, before_send: before_send}}
    >
      {children}
    </PostHogWebProvider>
  );
};
